// replace all \r\n and \r with \n
export const normalizeCarriageReturns = (str) => {
	return str.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
}

export const htmlEntities = (str) => {
	var doc = new DOMParser().parseFromString(str, 'text/html')
	return doc.documentElement.textContent
}
